import { PickupListsResponse } from './pickupListTypes';

export const mockPickupLists: PickupListsResponse = {
  pickupLists: [
    {
      downloadId: 'U2tsYWQgUHJhaGE.U2tsYWRvdmEgMQ.MTIwIDAw.MQ.MjAyNi0wOC0zMFQwMDowMA.MjAyNi0wOC0zMVQyMzo1OQ',
      place: {
        senderName: 'Sklad Praha',
        senderCompany: 'Joe Doe s.r.o.',
        street: 'Skladova 1',
        postcode: '120 00',
        city: 'Praha',
        countryCode: 'CZ',
      },
      carrierId: 1,
      carrierIdentifier: 'WEDO_HOME',
      orderCount: 2,
      packageCount: 3,
    },
    {
      downloadId: 'U2tsYWQgQnJubw..NjAyIDAw.Mg.MjAyNi0wOC0zMFQwMDowMA.MjAyNi0wOC0zMVQyMzo1OQ',
      place: {
        senderName: 'Sklad Brno',
        senderCompany: null,
        street: null,
        postcode: '602 00',
        city: 'Brno',
        countryCode: 'CZ',
      },
      carrierId: 2,
      carrierIdentifier: 'PPL_CZ',
      orderCount: 5,
      packageCount: 5,
    },
  ],
};

export const MOCK_PICKUP_LIST_CONTENT_DISPOSITION = 'attachment; filename="pickup-list-WEDOHOME-12000.pdf"';
